export const UPDATE_SELECTED_SERIE ='project/cap17andrive/update-selected-serie';
export const UPDATE_SELECTED_SEASON ='project/cap17andrive/update-selected-season';
export const UPDATE_SELECTED_EPISODE ='project/cap17andrive/update-selected-episode';
export const UPDATE_VIEW_EPISODE ='project/cap17andrive/update-view-episode';
